import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideCreateActivityModal } from '../../actions'
import _ from 'lodash';

import { CreateActivityModal } from './CreateActivityModal';
import { updateCreateActivityFormValues, clearCreateActivityModalValues, createActivity } from '../../actions/createActivity';
import { getProductAcronym } from '../../constants/products';
import { Scoring } from '../../constants/scoring';

class CreateActivityModalController extends Component {
    constructor(props) {
        super(props);

        this.formUpdated = this.formUpdated.bind(this);
        this.formSubmitted = this.formSubmitted.bind(this);
    }

    formSubmitted(event) {
        const {createActivity, data} = this.props;
        event.preventDefault();
        if( !data.isRequesting )
        {
            createActivity(data);            
        }
    }

    formUpdated(event) {
        const {updateCreateActivityFormValues, data} = this.props;
        const {target} = event;
        
        // Note this assumes that each field in the modal is named the same as the validation boolean
        // in the reducer's data, but in a readable fashion:
        // e.g.: Activity Name => activityName => activityNameValid
        // Where the first name is the name of the field in the modal, the second is the key generated from that name,
        // and the third is the name of validation boolean that we will update.
        const key = _.camelCase(target.name);
        let value = target.value;

        if(key === "scores"){
            if( target.checked ){
                value = Scoring.ScoresScores;
            }
            else{
                value = Scoring.ScoresDoesNotScore;
            }
        } else if(key === "product"){
            value = getProductAcronym(value);
        }

        updateCreateActivityFormValues({
            ...data,
            [key]: value,
            [`${key}Valid`]: isValid(key, target.value)
        });
    }

    render() {
        const {show, hideCreateActivityModal, data, clearCreateActivityModalValues} = this.props;

        return (
            <CreateActivityModal
                show={show}
                hide={() => {
                    clearCreateActivityModalValues();
                    hideCreateActivityModal();
                }}
                data={{
                    activityNameValidation:         validationState(data.activityNameValid),
                    productValidation:              validationState(data.productValid),
                    formValid:                      formValid(data),
                    isRequesting:                   data.isRequesting
                }}
                updated={this.formUpdated}
                submitted={this.formSubmitted}
                />
        );
    }
}

const isValid = (name, value) => {
    switch(name) {
        case 'activityName':        return !!value;
        case 'product':             return !!value;        
        default:                    return false;
    }
};

const validationState = isValid => {
    return isValid ? 'success' : 'error';
};

const formValid = data => {
    return data.activityNameValid &&
        data.productValid;
};

CreateActivityModalController.propTypes = {
    show:                           PropTypes.bool.isRequired,
    hideCreateActivityModal:        PropTypes.func.isRequired,
    data:                           PropTypes.object.isRequired,
    updateCreateActivityFormValues: PropTypes.func.isRequired,
    clearCreateActivityModalValues: PropTypes.func.isRequired,
    createActivity:                 PropTypes.func.isRequired
};

const mapDispatchToProps = {
    hideCreateActivityModal,
    clearCreateActivityModalValues,
    updateCreateActivityFormValues,
    createActivity
};

const mapStateToProps = state => ({
    data: state.ui.createActivityData,
    show: state.ui.createActivity.show
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateActivityModalController);



// WEBPACK FOOTER //
// ./src/components/createActivityModal/CreateActivityModalController.js